import { EMPTY_QUOTATION_MODEL } from "presentation/model/QuotationSetting/QuotationModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: QuotationProvider,
    useTracked: useQuotationTracked
} = createContainer(() => useState(EMPTY_QUOTATION_MODEL), { concurrentMode: true });
export { QuotationProvider, useQuotationTracked };

